import { createSlice } from "@reduxjs/toolkit";

const helpOverlaySlice = createSlice({
  name: "helpOverlay",
  initialState: {
    isOpen: false,
  },
  reducers: {
    openHelpOverlay: (state) => {
      state.isOpen = true;
    },
    closeHelpOverlay: (state) => {
      state.isOpen = false;
    },
    toggleHelpOverlay: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openHelpOverlay, closeHelpOverlay, toggleHelpOverlay } =
  helpOverlaySlice.actions;

export default helpOverlaySlice.reducer;
